/**
 * What the phone's chat notice says for a message that has just arrived
 * (Mobile in-session → Chat): who wrote and what — or null when there is
 * nothing to tell: a message in another conversation, or one of your own.
 *
 * @param {{ lastMessage?: object, messages?: object[] }} payload  the socket's group_messages_refresh
 * @param {{ chatId: string|number|null, myId: string|number|null }} where
 * @returns {{ name: string, text: string, avatar: string|null } | null}
 */
export const chatNoticeFrom = ({ lastMessage, messages } = {}, { chatId, myId } = {}) => {
  if (!lastMessage || chatId == null) return null;
  if (String(lastMessage.group) !== String(chatId)) return null;
  if (myId != null && String(lastMessage.user_id) === String(myId)) return null;

  const last = Array.isArray(messages) ? messages[messages.length - 1] : null;
  const author = Array.isArray(last?.user) ? last.user[0] : last?.user;
  const avatar = author?.avatar && !['null', 'undefined'].includes(author.avatar) ? author.avatar : null;

  return {
    name: lastMessage.full_name || author?.fullName || 'Somebody',
    text: lastMessage.message ?? '',
    avatar,
  };
};
